import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateCustomerModel from '@/models/createCustomerModel';
import UpdateCustomerModel from '@/models/updateCustomerModel';

export default class CustomerService {
  /**
   * @description: 查询客户信息
   * @page 页码
   * @size 每页大小
   * @return {Promise}
   */
  static getAll = (page: number, size: number, name?: string): Promise<IResponse> => {
    let url = `customer?page=${page}&size=${size}`;
    if (name) url += `&name=${name}`;
    return axiosInstance.get(url).then((res) => res.data);
  }

  /**
   * @description: 新增客户
   * @params {CreateCustomerModel} params
   * @return {Promise}
   */
  static create = (params: CreateCustomerModel): Promise<IResponse> => axiosInstance.post('customer', params).then((res) => res.data);

  /**
   * @description: 查询指定客户信息
   * @customerId 客户Id
   * @return {Promise}
   */
  static get = (customerId: string): Promise<IResponse> => axiosInstance.get(`customer/${customerId}`).then((res) => res.data);

  /**
   * @description: 修改指定客户信息
   * @customerId 客户Id
   * @return {Promise}
   */
  static update = (customerId: string, params: UpdateCustomerModel): Promise<IResponse> => axiosInstance.put(`customer/${customerId}`, params).then((res) => res.data);

  /**
   * @description: 删除指定客户
   * @customerId 客户Id
   * @return {Promise}
   */
   static delete = (customerId: string): Promise<IResponse> => axiosInstance.delete(`customer/${customerId}`).then((res) => res.data);
}
